import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { FormControl } from '@angular/forms';
import { debounceTime, distinctUntilChanged, map } from 'rxjs/operators';

@Component({
  selector: 'app-module-filter',
  templateUrl: './module-filter.component.html',
  styleUrls: ['./module-filter.component.css']
})
export class ModuleFilterComponent {

  @Output()
  onSearch = new EventEmitter<string>();

  searchBox = new FormControl();

  constructor() {
    this.searchBox
      .valueChanges
      .pipe(
        debounceTime(400),
        distinctUntilChanged()
      ).subscribe(term => {
        this.onSearch.emit(term);
      });
  }

}
